<template>
  <CenterModule />
</template>

<script>
import CenterModule from '@/components/Center.vue'

export default {
  name: 'PrematchDetailPage',
  components: { CenterModule },
}
</script>
